import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import Page from "../pages/Page";
import Home from "../pages/homepage/Home";
import About from "../pages/about/About";
import { useLocation } from "react-router-dom";
import Riskwise from "../pages/Riskwise";
import ConsultancyTraining from "../pages/consulting/ConsultancyTraining";
import Services from "../pages/services/Services";
import OurPeople from "../pages/about/OurPeople";
import Consulting from "../pages/consulting/Consulting";
import SingleConsultancy from "../pages/consulting/SingleConsultancy";
import Careers from "../pages/about/Careers";
import OurBusiness from "../pages/about/OurBusiness";
import Posts from "../posts/Posts";
import SinglePost from "../posts/SinglePost";
import Experiences from "../pages/experiences/Experiences";
import SingleExperience from "../pages/experiences/SingleExperience";
import Contact from "../pages/Contact";
import usePageTracking from "../functions/usePageTracking";
import Preview from "../preview/Preview";
import LandingPage from "../landingPages/LandingPage";
import LandingHeader from "../layout/LandingHeader";

export default function MainRoutes() {
  //   const posts = WP_API_Settings.posts_page_slug;

  //Jump back to top on route change - unless paginating
  const location = useLocation();
  usePageTracking();

  useEffect(() => {
    if (!location.pathname.includes("/page/")) {
      window.scrollTo({ top: 0 });
    }
  }, [location]);

  const isLandingPage = location.pathname.includes("/lp/");

  return (
    <>
      {isLandingPage ? null : <Header />}

      <Routes>
        <Route element={<Preview />}>
          {/* HOME */}
          <Route path="/" element={<Home />} />

          {/* ABOUT */}
          <Route path="/about/" element={<About />} />
          <Route path="/about/our-business/" element={<OurBusiness />} />
          <Route path="/about/our-people/" element={<OurPeople />} />
          <Route path="/about/careers/" element={<Careers />} />

          {/* SERVICES */}
          <Route path="/services/" element={<Services />} />
          <Route path="/services/consulting/" element={<Consulting />} />
          <Route
            path="/services/consulting/:slug"
            element={<SingleConsultancy />}
          />
          <Route path="/services/training" element={<ConsultancyTraining />} />

          {/* POSTS */}
          <Route path={"/insights/"} element={<Posts />} />
          <Route path={"/insights/page/:pageNum/"} element={<Posts />} />
          <Route
            path={"/insights/category/:categorySlug/"}
            element={<Posts />}
          />
          <Route
            path={"/insights/category/:categorySlug/page/:pageNum/"}
            element={<Posts />}
          />
          <Route path={"/insights/*"} element={<SinglePost />} />

          {/* EXPERIENCES */}
          <Route path="/experience/" element={<Experiences />} />
          <Route path="/experience/*" element={<SingleExperience />} />

          {/* LANDING PAGES */}
          <Route path="/lp/*" element={<LandingPage />} />

          {/* MISC PAGES */}
          <Route path="/*" element={<Page />} />

          {/* RISKWISE */}
          <Route
            path={"/services/s2-riskwise-software/"}
            element={<Riskwise />}
          />

          {/* CONTACT */}
          <Route path={"/contact/"} element={<Contact />} />
        </Route>
      </Routes>
      {isLandingPage ? null : <Footer />}
    </>
  );
}
